import React from 'react'
import SearchCompt from './SearchCompt'
import Cards from './Cards'

function Home() {
  return (
    <div>
<SearchCompt />
<Cards />
    </div>
  )
}

export default Home